import {redirect} from "react-router-dom";
import Treatments from "../../../services/UkTreatmentApi/Treatments";

export async function action({params}) {
    await Treatments.delete(params.treatmentId);

    return redirect(`/farms/${params.farmUid}/proactive_treatments`);
}